import { render } from "./B2bTableMenuCierresContables.vue?vue&type=template&id=acda12c2&scoped=true&lang=pug"
import script from "./B2bTableMenuCierresContables.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuCierresContables.vue?vue&type=script&lang=js"

import "./B2bTableMenuCierresContables.vue?vue&type=style&index=0&id=acda12c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acda12c2"]])

export default __exports__